module.exports = __webpack_public_path__ + "bc8a155096cb0c56943ee3f60ae94ce5.pdf";